import { render, staticRenderFns } from "./product-markers.vue?vue&type=template&id=45d5780c&"
import script from "./product-markers.vue?vue&type=script&lang=js&"
export * from "./product-markers.vue?vue&type=script&lang=js&"
import style0 from "./product-markers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d5780c')) {
      api.createRecord('45d5780c', component.options)
    } else {
      api.reload('45d5780c', component.options)
    }
    module.hot.accept("./product-markers.vue?vue&type=template&id=45d5780c&", function () {
      api.rerender('45d5780c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-markers.vue"
export default component.exports